<template>
    <div class="wrap-section-slider" id="topSlider" ref="topSlider">
        <div class="sp-slides">
            <div class="slide-item sp-slide">
                <div class="slide-image">
                    <img src="../assets/img/sections/home-top-background.jpg" alt="" />
                </div>
                <div class="slide-content">
                    <p class="top-title sp-layer" data-show-transition="left" data-hide-transition="up"
                        data-show-delay="400" data-hide-delay="100">
                        简单 高效 卓越
                    </p>
                    <div class="title sp-layer" data-show-transition="right" data-hide-transition="up"
                        data-show-delay="500" data-hide-delay="150">
                        联 盛 纸 业 & 联 盛 浆 纸
                    </div>
                    <div class="under-title sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="600" data-hide-delay="200">
                        welcome to liansheng
                    </div>
                    <div class="controls sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="800" data-hide-delay="250">
                        <a href="/company/lszy" class="btn btn-info">联盛纸业(龙海)有限公司</a>
                        <a href="/company/lsjz" class="btn btn-primary">联盛浆纸(漳州)有限公司</a>
                    </div>
                </div>
            </div>
            <div class="slide-item sp-slide">
                <div class="slide-image">
                    <img src="../assets/img/sections/home-top-background-2.jpg" alt="" />
                </div>
                <div class="slide-content sp-layer">
                    <p class="top-title sp-layer" data-show-transition="left" data-hide-transition="up"
                        data-show-delay="400" data-hide-delay="100">
                        Simple Efficient Excellent
                    </p>
                    <div class="title sp-layer" data-show-transition="right" data-hide-transition="up"
                        data-show-delay="500" data-hide-delay="150">
                        liansheng paper
                    </div>
                    <div class="under-title sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="600" data-hide-delay="200">
                        welcome to liansheng
                    </div>
                    <div class="controls sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="800" data-hide-delay="250">
                        <a href="/company/lszy" class="btn btn-info">&nbsp;liansheng paper&nbsp;</a>
                        <a href="/company/lsjz" class="btn btn-primary">liansheng pulp&paper</a>
                    </div>
                </div>
            </div>
            <div class="slide-item sp-slide">
                <div class="slide-image">
                    <img src="../assets/img/sections/home-top-background-3.jpg" alt="" />
                </div>
                <div class="slide-content">
                    <p class="top-title sp-layer" data-show-transition="left" data-hide-transition="up"
                        data-show-delay="400" data-hide-delay="100">
                        简单 高效 卓越
                    </p>
                    <div class="title sp-layer" data-show-transition="right" data-hide-transition="up"
                        data-show-delay="500" data-hide-delay="150">
                        联 盛 纸 业 & 联 盛 浆 纸
                    </div>
                    <div class="under-title sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="600" data-hide-delay="200">
                        welcome to liansheng
                    </div>
                    <div class="controls sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="800" data-hide-delay="250">
                        <a href="/company/lszy" class="btn btn-info">联盛纸业(龙海)有限公司</a>
                        <a href="/company/lsjz" class="btn btn-primary">联盛浆纸(漳州)有限公司</a>
                    </div>
                </div>
            </div>
            <div class="slide-item sp-slide">
                <div class="slide-image">
                    <img src="../assets/img/sections/home-top-background-4.jpg" alt="" />
                </div>
                <div class="slide-content sp-layer">
                    <p class="top-title sp-layer" data-show-transition="left" data-hide-transition="up"
                        data-show-delay="400" data-hide-delay="100">
                        Simple Efficient Excellent
                    </p>
                    <div class="title sp-layer" data-show-transition="right" data-hide-transition="up"
                        data-show-delay="500" data-hide-delay="150">
                        liansheng pulp&paper
                    </div>
                    <div class="under-title sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="600" data-hide-delay="200">
                        welcome to liansheng
                    </div>
                    <div class="controls sp-layer" data-show-transition="up" data-hide-transition="up"
                        data-show-delay="800" data-hide-delay="250">
                        <a href="/company/lszy" class="btn btn-info">&nbsp;liansheng paper&nbsp;</a>
                        <a href="/company/lsjz" class="btn btn-primary">liansheng pulp&paper</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { reqSliderList } from '../api';

const baseData = require("./Slider_default.json");

export default {
    name: 'Slider',
    props: {
        sliderData: Array
    },
    async mounted() {
        try {
            let jsonData = await reqSliderList(); // 调用异步函数获取数据  
            this.sliderData = jsonData.data; 
            console.log(jsonData);
        } catch (error) {
            console.error('Failed to fetch slider list:', error);
        }
    }
}

</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Slider.vue